import React from "react";
import { motion } from "framer-motion";
import profileImage from "../assets/team1.webp";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-yellow-50">
      <div className="container mx-auto px-4 pt-32 md:pt-44 pb-20">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mt-8">
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="w-48 md:w-64 lg:w-80"
          >
            <div className="relative">
              <motion.div
                className="absolute -inset-4 rounded-full border-2 border-yellow-400"
                animate={{ rotate: 360 }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
              />
              <div className="relative rounded-full overflow-hidden aspect-square bg-gradient-to-b from-yellow-100 to-white">
                <img
                  src={profileImage}
                  alt="OYEKA Amara"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </motion.div>

          <motion.div
            className="text-center md:text-left space-y-6 max-w-2xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-3xl md:text-5xl font-bold text-gray-800">
              OYEKA Amara Kate
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-600">
              Finance & Tax Expert | Tech Accountant |
              Business Strategist | Mentor | Author | Equity
              Advocate
            </h2>
            <p className="text-lg text-gray-600">
              A seasoned finance and tax expert, strategic leader, author and mentor, dedicated to
              driving revenue growth, governance, business strategy and women's empowerment
              through impactful leadership and advocacy.
            </p>
          </motion.div>
        </div>

        <motion.div
          className="mt-10 flex flex-col sm:flex-row justify-center items-center gap-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <motion.button
            className="w-full sm:w-auto px-8 py-3 bg-yellow-600 text-white rounded-lg font-semibold hover:bg-yellow-700 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link to="/contact">Book a Consultation</Link>
          </motion.button>
          <motion.button
            className="w-full sm:w-auto px-8 py-3 border-2 border-yellow-600 text-yellow-600 rounded-lg font-semibold hover:bg-yellow-50 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Link to="/about">Learn More</Link>
          </motion.button>
        </motion.div>

        <motion.div
          className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 px-4"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Financial Expertise</h3>
            <p className="text-gray-600">Strategic financial planning and management solutions for sustainable growth.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Tax Advisory</h3>
            <p className="text-gray-600">Comprehensive tax planning and compliance services for businesses and individuals.</p>
          </div>
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Leadership Mentorship</h3>
            <p className="text-gray-600">Transformative mentorship programs fostering the next generation of leaders.</p>
          </div>
        </motion.div>

        <motion.div
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.8 }}
        >
          <div className="p-4">
            <h4 className="text-3xl font-bold text-yellow-600">17+</h4>
            <p className="text-gray-600">Years Experience</p>
          </div>
          <div className="p-4">
            <h4 className="text-3xl font-bold text-yellow-600">50+</h4>
            <p className="text-gray-600">Clients Served</p>
          </div>
          <div className="p-4">
            <h4 className="text-3xl font-bold text-yellow-600">30+</h4>
            <p className="text-gray-600">Mentees</p>
          </div>
          <div className="p-4">
            <h4 className="text-3xl font-bold text-yellow-600">95%</h4>
            <p className="text-gray-600">Client Satisfaction</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Home;
